import React, { ReactNode } from 'react';
type PillProps = {
  variant?: 'green' | 'neutral' | 'navy' | 'outline';
  children: ReactNode;
};
const variants: Record<NonNullable<PillProps['variant']>, string> = {
  green: 'bg-green-soft text-green-deep border border-green/25',
  neutral: 'bg-mist-deep text-ink-muted border border-line',
  navy: 'bg-white/8 text-white/75 border border-white/15',
  outline: 'bg-transparent text-green border border-green/40'
};
export function Pill({
  variant = 'neutral',
  children
}: PillProps) {
  return <span className={`inline-flex items-center rounded-full px-3 py-1 font-sans text-[11px] font-medium leading-none tracking-wide ${variants[variant]}`} data-id="element-196" data-mp="14no80irx2pla">
      {children}
    </span>;
}